import React from 'react';
import cl from '../BaseSimplePage/BaseSimpleItemEditor.module.css'
import {Alert} from "@mui/material";
import SubscriptionCancellationsSummaryItemForm from "./SubscriptionCancellationsSummaryItemForm";

const SubscriptionCancellationsSummaryEditor = ({
                                    summaryData,
                                }) => {

    return (
        <div className={cl.main}>
            <div className={cl.scrollContent}>

                {summaryData && !Boolean(summaryData.total) && <Alert severity={"info"}>Поиск не дал результатов</Alert>}
                {summaryData && Boolean(summaryData.total) && <SubscriptionCancellationsSummaryItemForm
                    initData={summaryData}
                />}
            </div>
        </div>
    );
};

export default SubscriptionCancellationsSummaryEditor;